exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, "/*Variables*/\nbody, html {\n  margin: -1vh auto 0 auto;\n  padding: -1vh 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Abel\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #0f8a7c;\n  overflow-y: auto;\n  font-size: calc(18px + (24 - 18) * ((100vw - 300px) / (1200 - 300))); }\n", ""]);

// exports
